<template>
  <div>
    <v-data-table
      :headers="userHeaders"
      :items="filteredUsers"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:top>
        <search style="width:50%;" />
        <v-row no-gutters justify="space-between" align="center" class="pa-3">
          <v-switch
            v-model="showAdmin"
            :label="userLabel"
            color="primary"
            id="system-users-admin-switch"
          ></v-switch>
          <v-spacer />
          <v-btn
            class="mr-4 d-flex align-center"
            small
            color="secondary"
            v-if="showMobileView"
            @click="_setFilters(true)"
          >
            <v-icon color="white">mdi-filter</v-icon>
          </v-btn>
          <v-btn
            small
            color="secondary"
            v-if="showMobileView"
            @click="_setNewInvite(true)"
          >
            <v-row>
              <v-spacer />
              <v-col>
                <v-icon color="white">mdi-plus</v-icon>
              </v-col>
            </v-row>
          </v-btn>
          <v-btn
            height="48"
            width="48"
            small
            color="secondary"
            v-if="!showMobileView"
            @click="_setNewInvite(true)"
          >
            <v-icon color="white" class="ma-0 pa-0" id="add-new-user"
              >mdi-plus</v-icon
            >
          </v-btn>
        </v-row>
      </template>
      <template v-slot:item.uuid="{ item }">
        <!-- <v-icon medium class="pr-3" id="user-refresh">mdi-refresh</v-icon> -->
        <v-btn class="mr-3" @click="openEdit(item)" icon small>
          <v-icon medium id="edit-user">mdi-pencil</v-icon>
        </v-btn>
        <v-btn @click="openDelete(item)" icon small>
          <v-icon medium color="primary" id="delete-user" class="pr-4"
            >mdi-trash-can</v-icon
          >
        </v-btn>
      </template>
    </v-data-table>
    <edit-user :data="editData" v-if="editData" />
    <delete-user :data="deleteData" v-if="deleteData" :userType="userType" />
    <filters />
    <v-snackbar v-model="snackbar" :timeout="timeout" id="company-snackbar">
      {{ _getError }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Search from '@/components/app/Search';
// import Tables from "@/components/app/Table.vue";
// import Filters from "@/components/filter/Filters";
import { MobileView } from '@/mixins';
import EditUser from '@/components/account/EditUser';
import DeleteUser from '@/components/account/DeleteUser';
import FormatPhone from '@/mixins/FormatPhone';

export default {
  components: {
    Search,
    // Tables,
    // Filters,
    EditUser,
    DeleteUser,
  },
  mixins: [MobileView, FormatPhone],
  data: () => ({
    userHeaders: [
      { text: 'Name', value: 'user_name' },
      { text: 'Email', value: 'email' },
      { text: 'Phone Number', value: 'phone' },
      { text: '', value: 'uuid' },
    ],
    showAdmin: false,
    snackbar: false,
    snackbarText: '',
    timeout: 6000,
    editData: null,
    deleteData: null,
  }),
  computed: {
    ...mapGetters({
      _dataset: 'account/getAllUsers',
      _getQueryParams: 'account/getQueryParams',
      _getUsersFilter: 'filters/getUsersFilter',
      _getError: 'auth/getError',
      _getUserType: 'account/getUserType',
      _client: 'account/getCurrentClient',
    }),
    userType: {
      get() {
        return this._getUserType;
      },
      set(val) {
        this._setUserType(val);
      },
    },
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
    buttonStyle() {
      if (this.showMobileView) {
        return 'mr-4 mt-4 d-flex align-center';
      }
      return 'mr-4 mt-0 d-flex align-center';
    },
    userLabel() {
      if (this.userType === 'user') {
        return 'Users';
      }
      return 'Admins';
    },
    pageStyle() {
      if (this.showMobileView) {
        return 'd-flex';
      }
      return 'd-flex flex-column';
    },
    filteredUsers() {
      const users = [];
      this._dataset.map(user => {
        if (user.client_id.includes(this._client.client_name)) {
          users.push(user);
        }
      });
      return users;
    },
  },
  mounted() {
    this._getAllUsers();
    this._setError(null);
  },
  methods: {
    ...mapMutations({
      _setFilters: 'filters/setFilters',
      _setNewInvite: 'account/setNewInvite',
      _setQueryParams: 'account/setQueryParams',
      _setEdit: 'account/setEditUser',
      _setDelete: 'account/setDeleteUser',
      _setError: 'auth/setError',
      _setUserType: 'account/setUserType',
    }),
    ...mapActions({
      _getAllUsers: 'account/getAllUsers',
    }),
    openEdit(data) {
      this.editData = data;
      this._setEdit(true);
    },
    openDelete(data) {
      this.deleteData = data;
      this._setDelete(true);
    },
  },
  watch: {
    queryParams: {
      handler() {
        this._getAllUsers();
      },
      deep: true,
    },
    _getError() {
      this.snackbar = true;
      if (this._getError === null) {
        this.snackbar = false;
      }
    },
    snackbar() {
      if (!this.snackbar) {
        this._setError(null);
      }
    },
    showAdmin() {
      if (this.showAdmin) {
        this.userType = 'admin';
        this._getAllUsers('admin');
      } else {
        this.userType = 'user';
        this._getAllUsers('user');
      }
    },
  },
};
</script>

<style></style>
